import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import Color from '../../../../shared/assets/style/default/color';

interface Props {
  active: boolean;
}

const SwitcherBall = styled.div<Props>`
  width: ${65 * Screen.widthRatio}px;
  height: ${65 * Screen.widthRatio}px;
  background: ${(props) => (props.active ? Color.modal.title : 'grey')};
  border-radius: ${88 * Screen.widthRatio}px;
  position: relative;
  top: ${6 * Screen.widthRatio}px;
  left: ${7 * Screen.widthRatio}px;
  transition: transform 0.6s, background 1s;
  -webkit-transition: transform 0.6s, background 1s;
`;

export default SwitcherBall;
